import { useState, useEffect } from 'react';

/**
 * Custom hook to detect mobile viewport
 * @param {number} breakpoint - The breakpoint in pixels (default: 768)
 * @returns {boolean} - Whether the viewport is mobile-sized
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const query = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const update = () => setIsMobile(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, [breakpoint]);

  return isMobile;
}

export default useIsMobile;
